import React, { useEffect } from 'react';
import CompanySelect from './pages/CompanySelect';
import Code128Diagnostic from './pages/Code128Diagnostic';
import Home from './pages/Home';
import Login from './pages/Login';
import MyTasks from './pages/MyTasks';
import MyHolding from './pages/MyHolding';
import MyPmiDetectionHistory from './pages/MyPmiDetectionHistory';
import OffcutTrace from './pages/OffcutTrace';
import PmiScan from './pages/PmiScan';
import ContinuousPmiScan from './pages/ContinuousPmiScan';
import LabelVerification from './pages/LabelVerification';
import RawMaterialTrace from './pages/RawMaterialTrace';
import ScanDeliveryPalletBind from './pages/ScanDeliveryPalletBind';
import ScanOffcutInbound from './pages/ScanOffcutInbound';
import ScanOffcutOutbound from './pages/ScanOffcutOutbound';
import ScanOffcutTransfer from './pages/ScanOffcutTransfer';
import ScanPreInbound from './pages/ScanPreInbound';
import {
  AppRoutePath,
  navigateTo,
  protectedRoutePaths,
  useHashPath,
} from './utils/navigation';
import { hasStoredCompany, hasStoredSession } from './utils/session';
import './App.css';

function resolvePage(path: AppRoutePath, hasSession: boolean, hasCompany: boolean): AppRoutePath {
  if (path === '/') {
    if (!hasSession) {
      return '/login';
    }

    return hasCompany ? '/home' : '/company-select';
  }

  if (!hasSession && protectedRoutePaths[path]) {
    return '/login';
  }

  if (hasSession && !hasCompany && (path === '/login' || protectedRoutePaths[path])) {
    return '/company-select';
  }

  if (hasSession && hasCompany && path === '/company-select') {
    return '/home';
  }

  if (hasSession && path === '/login') {
    return '/home';
  }

  return path;
}

function App() {
  const hasSession = hasStoredSession();
  const hasCompany = hasStoredCompany();
  const path = useHashPath();
  const page = resolvePage(path, hasSession, hasCompany);

  useEffect(() => {
    if (page !== path) {
      navigateTo(page, true);
    }
  }, [page, path]);

  return (
    <div className="app-shell">
      {page === '/login' ? <Login /> : null}
      {page === '/company-select' ? <CompanySelect /> : null}
      {page === '/diagnostics/code128' ? <Code128Diagnostic /> : null}
      {page === '/home' ? <Home /> : null}
      {page === '/my-holding' ? <MyHolding /> : null}
      {page === '/pmi-history' ? <MyPmiDetectionHistory /> : null}
      {page === '/tasks' ? <MyTasks /> : null}
      {page === '/pmi-scan' ? <PmiScan /> : null}
      {['/pmi-continuous', '/pmi-group', '/scan/pmi-rebind'].includes(page) ? <ContinuousPmiScan /> : null}
      {page === '/scan/delivery-pallet-bind' ? <ScanDeliveryPalletBind /> : null}
      {page === '/scan/label-verification' ? <LabelVerification /> : null}
      {page === '/scan/inbound' ? <ScanOffcutInbound /> : null}
      {page === '/scan/pre-inbound' ? <ScanPreInbound /> : null}
      {page === '/scan/outbound' ? <ScanOffcutOutbound /> : null}
      {page === '/scan/transfer' ? <ScanOffcutTransfer /> : null}
      {page === '/trace' ? <OffcutTrace /> : null}
      {page === '/trace/raw-material' ? <RawMaterialTrace /> : null}
    </div>
  );
}

export default App;
